import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Notifications from './Components/System/Notifications';
import BaseRouter from './Components/Routes/BaseRouter';
import { CosmosThemeProvider } from 'cosmos-components';
import { useSelector } from 'react-redux';
import { getAppearance, getMaintenanceMode } from './Selectors/ui';
import { GlobalStyle } from 'cosmos-core';
import MaintenancePage from './Components/Maintenance/MaintenancePage';
import React, { useEffect, useState } from 'react';

const App = () => {
  const appearance = useSelector(getAppearance);
  const maintenanceMode = useSelector(getMaintenanceMode);

  const [bypass, setBypass] = useState(false);

  useEffect(() => {
    const bypassStored = sessionStorage.getItem('bypassMaintenance') === 'true';
    setBypass(bypassStored);
  }, []);

  const handleBypass = () => {
    sessionStorage.setItem('bypassMaintenance', 'true');
    setBypass(true);
  };

  const isMaintenanceMode = maintenanceMode && !bypass;

  if (isMaintenanceMode) {
    return (
      <>
      <MaintenancePage />
      <button
        onClick={handleBypass}
        style={{
          position: 'absolute',
          bottom: 10,
          right: 10,
          opacity: 0,
          width: 50,
          height: 50,
          pointerEvents: 'auto',
        }}
        aria-label="Hidden bypass"
      />
    </>
    );
  }

  return (
    <div>
      <CosmosThemeProvider theme={appearance?.cosmosTheme || 'light'}>
        <GlobalStyle />
        <BrowserRouter future={{ v7_startTransition: true }}>
            <BaseRouter />
            <ToastContainer />
            <Notifications />
          </BrowserRouter>
      </CosmosThemeProvider>
    </div>
  );
};

export default App;
